require("source-map-support").install(), function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Margin", [], t) : "object" == typeof exports ? exports.Margin = t() : e.Margin = t();
}(this, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 378);
  }({
    0: function _(e, t) {
      e.exports = require("react");
    },
    1: function _(e, t) {
      e.exports = require("prop-types");
    },
    13: function _(e, t, n) {
      "use strict";

      var r = n(3),
          o = n.n(r),
          i = n(0),
          u = n.n(i),
          a = n(1),
          c = n.n(a),
          f = n(2),
          p = n.n(f),
          s = n(7);

      function l() {
        var e = o()(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
        return l = function l() {
          return e;
        }, e;
      }

      var m = p()(function (e) {
        var t = e.children,
            n = e.className;
        return u.a.Children.only(u.a.cloneElement(t, {
          className: n
        }));
      })(l(), function (e) {
        var t = e.margin;
        return Object(s.a)({
          attribute: "margin",
          value: t
        });
      }, function (e) {
        var t = e.marginTop;
        return Object(s.a)({
          attribute: "margin-top",
          value: t
        });
      }, function (e) {
        var t = e.marginBottom;
        return Object(s.a)({
          attribute: "margin-bottom",
          value: t
        });
      }, function (e) {
        var t = e.marginLeft;
        return Object(s.a)({
          attribute: "margin-left",
          value: t
        });
      }, function (e) {
        var t = e.marginRight;
        return Object(s.a)({
          attribute: "margin-right",
          value: t
        });
      });
      m.propTypes = {
        margin: c.a.oneOfType([c.a.string, c.a.number]),
        marginTop: c.a.oneOfType([c.a.string, c.a.number]),
        marginBottom: c.a.oneOfType([c.a.string, c.a.number]),
        marginLeft: c.a.oneOfType([c.a.string, c.a.number]),
        marginRight: c.a.oneOfType([c.a.string, c.a.number])
      }, t.a = m;
    },
    189: function _(e, t, n) {
      "use strict";

      n.r(t);
      var r = n(13);
      t.default = r.a;
    },
    2: function _(e, t) {
      e.exports = require("styled-components");
    },
    3: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    378: function _(e, t, n) {
      e.exports = n(189);
    },
    7: function _(e, t, n) {
      "use strict";

      var r = n(3),
          o = n.n(r),
          i = n(2);

      function u() {
        var e = o()(["", ": ", ""]);
        return u = function u() {
          return e;
        }, e;
      }

      function a() {
        var e = o()(["", ": ", "px"]);
        return a = function a() {
          return e;
        }, e;
      }

      t.a = function (e) {
        var t = e.attribute,
            n = e.value;

        if (void 0 !== n) {
          if ("number" == typeof n) return Object(i.css)(a(), t, n);
          if ("string" == typeof n) return Object(i.css)(u(), t, n);
          throw new Error("".concat(n, " is not of valid type for ").concat(t, ".\n      prop can either number or string"));
        }
      };
    }
  });
});